import { JsonSerializable } from '@/util/object/JsonSerializable'
import { AdImageResponse } from '@/cowboy/reward_link/object/ad_campaign/AdImageResponse'
import { AdAssociatedBrandResponse } from '@/cowboy/reward_link/object/ad_campaign/AdAssociatedBrandResponse'
import { AdCampaignStatus } from '@/cowboy/EnumTypes'

export class AdCampaignResponse extends JsonSerializable {
  /** @type {number} */
  #adCampaignId
  /** @type {string} */
  #name
  /** @type {boolean} */
  #isGlobal
  /** @type {Date} */
  #startDate
  /** @type {Date} */
  #endDate
  /** @type {AdCampaignStatus} */
  #status
  /** @type {Date} */
  #createdDate
  /** @type {string} */
  #notes
  /** @type {Array<AdImageResponse>} */
  #adCampaignImages
  /** @type {Array<AdAssociatedBrandResponse>} */
  #adAssociatedBrands

  constructor (jsonObject) {
    super()
    this.#adCampaignId = Number.parseInt(jsonObject.adCampaignId) || undefined
    this.#name = jsonObject.name
    this.#isGlobal = Boolean(String(jsonObject.isGlobal).toLowerCase() === 'true')
    this.#startDate = new Date(jsonObject.startDate || undefined)
    this.#endDate = new Date(jsonObject.endDate || undefined)
    this.#status = AdCampaignStatus.fromJSON(jsonObject.status)
    this.#createdDate = new Date(jsonObject.createdDate || undefined)
    this.#notes = jsonObject.notes
    this.#adCampaignImages = jsonObject.adCampaignImages?.map(adCampaignImage => AdImageResponse.fromJSON(adCampaignImage)) || []
    this.#adAssociatedBrands = jsonObject.adAssociatedBrands?.map(adAssociatedBrand => AdAssociatedBrandResponse.fromJSON(adAssociatedBrand)) || []
    Object.freeze(this)
  }

  get adCampaignId () {
    return this.#adCampaignId
  }

  get name () {
    return this.#name
  }

  get isGlobal () {
    return this.#isGlobal
  }

  get startDate () {
    return this.#startDate
  }

  get endDate () {
    return this.#endDate
  }

  get status () {
    return this.#status
  }

  get createdDate () {
    return this.#createdDate
  }

  get notes () {
    return this.#notes
  }

  get adCampaignImages () {
    return this.#adCampaignImages
  }

  get adAssociatedBrands () {
    return this.#adAssociatedBrands
  }

  /**
   * @return {Object}
   */
  toJSON () {
    return {
      adCampaignId: this.#adCampaignId,
      name: this.#name,
      isGlobal: this.#isGlobal,
      startDate: this.#startDate?.valueOf() || undefined,
      endDate: this.#endDate?.valueOf() || undefined,
      status: this.#status?.toJSON(),
      createdDate: this.#createdDate?.valueOf() || undefined,
      notes: this.#notes,
      adCampaignImages: this.#adCampaignImages?.map(adCampaignImage => adCampaignImage.toJSON()),
      adAssociatedBrands: this.#adAssociatedBrands?.map(adAssociatedBrand => adAssociatedBrand.toJSON())
    }
  }

  /**
   * @param {Object} jsonObject
   * @return {AdCampaignResponse|undefined}
   */
  static fromJSON (jsonObject) {
    return (jsonObject && new AdCampaignResponse(jsonObject)) || undefined
  }
}
